import AddDimensionListSearch from './AddDimensionListSearch';

export default AddDimensionListSearch;
